export enum ButtonVariant {
  Primary,
  Secondary,
  Tertiary,
  Quaternary,
  Refusal,
  Error,
  Default,
  Disabled,
  Yellow,
  NotAllowed
}
